export default {
  completed_on_time: {
    status: 'Completed',
    taskStatusOnComplete: '',
    extendText: 'On Time',
    textColor1: 'secondary--text',
    textColor2: 'green--text',
    bgClass: 'green lighten-4'
  },
  completed_overdue: {
    status: 'Completed',
    taskStatusOnComplete: '',
    extendText: 'Overdue',
    textColor1: 'secondary--text',
    textColor2: 'orange--text text--darken-2',
    bgClass: 'green lighten-4'
  },
  completed_critical: {
    status: 'Completed',
    taskStatusOnComplete: '',
    extendText: 'Critical',
    textColor1: 'secondary--text',
    textColor2: 'red--text',
    bgClass: 'green lighten-4'
  },
  dueIn0: {
    status: 'Due Today',
    taskStatusOnComplete: 'completed_on_time',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'orange--text',
    bgClass: 'yellow lighten-4'
  },
  dueIn1: {
    status: 'Due Tomorrow',
    taskStatusOnComplete: 'completed_on_time',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'orange--text',
    bgClass: 'yellow lighten-4'
  },
  dueIn2: {
    status: 'Due in 2 Days',
    taskStatusOnComplete: 'completed_on_time',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'orange--text',
    bgClass: 'yellow lighten-4'
  },
  critical: {
    status: 'Critical',
    taskStatusOnComplete: 'completed_critical',
    extendText: '',
    textColor1: 'white--text',
    textColor2: 'orange--text',
    bgClass: 'red darken-4'
  },
  overdue: {
    status: 'Overdue',
    taskStatusOnComplete: 'completed_overdue',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'red--text',
    bgClass: 'pink lighten-5'
  },
  inProgress: {
    status: 'In Progress',
    taskStatusOnComplete: 'completed_on_time',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'secondary--text',
    bgClass: 'indigo lighten-4'
  },
  pending: {
    status: 'Pending',
    taskStatusOnComplete: 'completed_on_time',
    extendText: '',
    textColor1: 'secondary--text',
    textColor2: 'secondary--text',
    bgClass: 'grey lighten-3'
  }
}
